import merge from 'lodash/merge';

export default function entitiesReducer(state = {}, action) {
  if (!action.payload) {
    return state;
  }

  if (!action.payload.entities) {
    return state;
  }

  if (action.meta && action.meta.content) {
    return state;
  }

  return merge({}, state, action.payload.entities);
}



// WEBPACK FOOTER //
// ./src/store/entities/reducer.js